























































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";
import qs from "qs";
import _ from "lodash";
import moment from "moment";

@Component
export default class extends Mixins(MyList) {
  dispatchType = "track/list";

  columns: any[] = [
    { title: "模块", dataIndex: "level1" },
    { title: "页面", dataIndex: "level2" },
    { title: "步骤", dataIndex: "level3" },
    { title: "操作用户数", dataIndex: "ccount", sorter: true },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
  }
}
